import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop - resets scroll position to top whenever the pathname changes.
 * Place inside <BrowserRouter> to enable for all routes.
 */
export const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};
